const GLYPH_BY_LABEL: Record<string, string> = {
  Person: 'PER',
  TypesensePerson: 'PER',
  Company: 'ORG',
  TypesenseCompany: 'ORG',
  Organization: 'ORG',
  CorporateRole: 'ORG',
  Role: 'ORG',

  Location: 'LOC',
  Property: 'LOC',
  Address: 'LOC',

  BTSStation: 'BTS',
  FuelStation: 'FUE',
  TrainCrossing: 'RAI',

  MobileDevice: 'DEV',
  PhoneNumber: 'TEL',
  Phone: 'TEL',
  Vehicle: 'VEH',

  SocialAccount: 'SOC',
  ServiceSender: 'SVC',

  BankAccount: 'FIN',
  IBAN: 'FIN',
  ExchangeAccount: 'FIN',
  Payment: 'FIN',
  Transaction: 'FIN',

  Event: 'EVT',
  OffchainEvent: 'EVT',
  DailySummary: 'EVT',
  GroupOfDailySummaries: 'EVT',
  DailyTrading: 'EVT',

  Email: 'EML',
  EmailAddress: 'EML',

  Document: 'DOC',
  SourceSnippet: 'TAB',
}

export function glyphForLabels(labels: readonly string[] | undefined | null): string {
  if (!labels || labels.length === 0) return '???'
  for (const label of labels) {
    const hit = GLYPH_BY_LABEL[label]
    if (hit) return hit
  }
  const first = labels[0]
  return first.slice(0, 3).toUpperCase().padEnd(3, '?')
}
